
import React, { useState, useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import Layout from "@/components/layout/Layout";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/components/auth/AuthProvider";
import { NursingHomeLeads } from "@/components/dashboard/NursingHomeLeads";
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { useDashboardData } from "@/hooks/use-dashboard-data";
import { useIsMobile } from "@/hooks/use-mobile";

export default function Dashboard() {
  const { user, isLoading: authLoading } = useAuth();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { nursingHomeLeads, isLoading, refetch } = useDashboardData(user, refreshTrigger);
  const isMobile = useIsMobile();

  // Function to trigger data refresh
  const handleLeadUpdate = useCallback(() => {
    console.log("Updating leads...");
    // Increment refresh trigger to force data refetch
    setRefreshTrigger(prev => prev + 1);
  }, []);

  // Redirect to login if not authenticated
  if (!authLoading && !user) {
    return <Navigate to="/auth/login?redirectTo=/dashboard" />;
  }

  return (
    <Layout>
      <Helmet>
        <title>My Dashboard | Grandpal</title>
      </Helmet>

      <div className="container py-4 md:py-8 max-w-7xl">
        <DashboardHeader user={user} />
        
        <div className="grid grid-cols-1 gap-4 md:gap-6">
          <NursingHomeLeads 
            leads={nursingHomeLeads} 
            onLeadUpdate={handleLeadUpdate} 
          />
        </div>
      </div>
    </Layout>
  );
}
